import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type Department = {
  __typename?: 'Department';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  label: Label;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DepartmentInput = {
  label: LabelInput;
};

export type Email = {
  __typename?: 'Email';
  address: Scalars['String'];
  createdAt: Scalars['DateTime'];
  isVerified: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailInput = {
  address: Scalars['String'];
};

export type EnrolledTag = {
  __typename?: 'EnrolledTag';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  readerId: Scalars['String'];
  tagDecimalId: Scalars['String'];
  tagHexId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ExtendedReport = {
  __typename?: 'ExtendedReport';
  _id: Scalars['String'];
  completeJson?: Maybe<ReportObject>;
  createdAt: Scalars['DateTime'];
  csv?: Maybe<ReportObject>;
  json?: Maybe<ReportObject>;
  label: Label;
  lastUpdatedByUser?: Maybe<User>;
  readerIds?: Maybe<Array<Scalars['String']>>;
  readers?: Maybe<Array<Reader>>;
  sinceDate: Scalars['DateTime'];
  status: ReportStatus;
  type: ReportTypes;
  untilDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userIds?: Maybe<Array<Scalars['String']>>;
  users?: Maybe<Array<User>>;
  workingHours?: Maybe<Scalars['Float']>;
};

export type ExtendedTag = {
  __typename?: 'ExtendedTag';
  _id: Scalars['String'];
  assignedAt?: Maybe<Scalars['DateTime']>;
  assignedToUserId?: Maybe<Scalars['String']>;
  batteryStatus: TagBatteryStatus;
  createdAt: Scalars['DateTime'];
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  status: TagStatus;
  tagDecimalId: Scalars['String'];
  tagHexId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

export type FieldError = {
  __typename?: 'FieldError';
  error: Scalars['String'];
  field: Scalars['String'];
};

export type FinishUploadInput = {
  key: Scalars['String'];
};

export type Label = {
  __typename?: 'Label';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LabelInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateTagOfUser: Tag;
  activateUser: User;
  addFCMToken: Scalars['Boolean'];
  assignTag: Tag;
  assignUserRole: UserRole;
  changePassword: Scalars['Boolean'];
  createDepartment: Department;
  createPermissionsGroup: PermissionsGroup;
  createReader: Reader;
  createService: Service;
  createTag: Tag;
  createUser: User;
  createUserType: UserType;
  deactivateTagOfUser: Tag;
  deactivateUser: User;
  deletePermissionsGroup: Scalars['Boolean'];
  deleteService: Scalars['Boolean'];
  deleteUserType: Scalars['Boolean'];
  extendUserRole: UserRole;
  finishAvatarUpload: Picture;
  flushTag: Tag;
  generateUserAttendanceReport: ExtendedReport;
  login: UserAuthResponse;
  logout: Scalars['Boolean'];
  removeCurrentUserRole: Scalars['Boolean'];
  sendEmailVerificationSecretCode: Scalars['Boolean'];
  signAvatarUpload: UploadSignatureResponse;
  updateDepartment: Department;
  updatePermissionsGroup: PermissionsGroup;
  updateReader: Reader;
  updateService: Service;
  updateUser: User;
  updateUserPermissionsGroups: Array<PermissionsGroup>;
  updateUserType: UserType;
  verifyEmailWithSecretCode: Scalars['Boolean'];
};


export type MutationActivateTagOfUserArgs = {
  userId: Scalars['String'];
};


export type MutationActivateUserArgs = {
  userId: Scalars['String'];
};


export type MutationAddFcmTokenArgs = {
  token: Scalars['String'];
};


export type MutationAssignTagArgs = {
  tagDecimalId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationAssignUserRoleArgs = {
  input: UserRoleInput;
  userId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  shouldLogOutOnOtherDevices?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreatePermissionsGroupArgs = {
  input: PermissionsGroupInput;
};


export type MutationCreateReaderArgs = {
  input: ReaderInput;
};


export type MutationCreateServiceArgs = {
  input: ServiceInput;
};


export type MutationCreateTagArgs = {
  tagDecimalId: Scalars['String'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateUserTypeArgs = {
  input: UserTypeInput;
};


export type MutationDeactivateTagOfUserArgs = {
  userId: Scalars['String'];
};


export type MutationDeactivateUserArgs = {
  userId: Scalars['String'];
};


export type MutationDeletePermissionsGroupArgs = {
  permissionsGroupId: Scalars['String'];
};


export type MutationDeleteServiceArgs = {
  serviceId: Scalars['String'];
};


export type MutationDeleteUserTypeArgs = {
  userTypeId: Scalars['String'];
};


export type MutationExtendUserRoleArgs = {
  expireAt: Scalars['DateTime'];
  userId: Scalars['String'];
};


export type MutationFinishAvatarUploadArgs = {
  input: FinishUploadInput;
  userId: Scalars['String'];
};


export type MutationFlushTagArgs = {
  userId: Scalars['String'];
};


export type MutationGenerateUserAttendanceReportArgs = {
  input: UserAttendanceReportInput;
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationRemoveCurrentUserRoleArgs = {
  userId: Scalars['String'];
};


export type MutationSignAvatarUploadArgs = {
  format: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUpdateDepartmentArgs = {
  departmentId: Scalars['String'];
  input: DepartmentInput;
};


export type MutationUpdatePermissionsGroupArgs = {
  input: PermissionsGroupInput;
  permissionsGroupId: Scalars['String'];
};


export type MutationUpdateReaderArgs = {
  input: ReaderInput;
  readerId: Scalars['String'];
};


export type MutationUpdateServiceArgs = {
  input: ServiceInput;
  serviceId: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UserInput;
  userId: Scalars['String'];
};


export type MutationUpdateUserPermissionsGroupsArgs = {
  permissionsGroupIds: Array<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationUpdateUserTypeArgs = {
  input: UserTypeInput;
  userTypeId: Scalars['String'];
};


export type MutationVerifyEmailWithSecretCodeArgs = {
  code: Scalars['String'];
};

export type PaginatedDepartmentsResponse = {
  __typename?: 'PaginatedDepartmentsResponse';
  currentPage: Scalars['Float'];
  departments: Array<Department>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
};

export type PaginatedInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Float']>;
};

export type PaginatedPermissionsGroupsResponse = {
  __typename?: 'PaginatedPermissionsGroupsResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  permissionsGroups: Array<PermissionsGroup>;
};

export type PaginatedReaderStatusLogsResponse = {
  __typename?: 'PaginatedReaderStatusLogsResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  readerStatusLogs: Array<ReaderStatusLog>;
};

export type PaginatedReadersResponse = {
  __typename?: 'PaginatedReadersResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  readers: Array<Reader>;
};

export type PaginatedReportsResponse = {
  __typename?: 'PaginatedReportsResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  reports: Array<Report>;
};

export type PaginatedTagsResponse = {
  __typename?: 'PaginatedTagsResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  tags: Array<ExtendedTag>;
};

export type PaginatedUserAttendanceRecordsResponse = {
  __typename?: 'PaginatedUserAttendanceRecordsResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  userAttendanceRecords: Array<UserAttendanceRecord>;
};

export type PaginatedUserTypesResponse = {
  __typename?: 'PaginatedUserTypesResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  userTypes: Array<UserType>;
};

export type PaginatedUsersResponse = {
  __typename?: 'PaginatedUsersResponse';
  currentPage: Scalars['Float'];
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  users: Array<User>;
};

export type PermissionsGroup = {
  __typename?: 'PermissionsGroup';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  isPrivateToAdmin?: Maybe<Scalars['Boolean']>;
  label: Label;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PermissionsGroupInput = {
  isPrivateToAdmin?: InputMaybe<Scalars['Boolean']>;
  label: LabelInput;
  tags: Array<Scalars['String']>;
};

export type Phone = {
  __typename?: 'Phone';
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type PhoneInput = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type Picture = {
  __typename?: 'Picture';
  original: PictureObject;
  variants?: Maybe<PictureVariants>;
};

export type PictureObject = {
  __typename?: 'PictureObject';
  height: Scalars['Float'];
  key: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type PictureVariants = {
  __typename?: 'PictureVariants';
  large?: Maybe<PictureObject>;
  medium?: Maybe<PictureObject>;
  small?: Maybe<PictureObject>;
  thumbnail?: Maybe<PictureObject>;
};

export type Query = {
  __typename?: 'Query';
  activeAttendanceOfUser?: Maybe<UserAttendanceRecord>;
  activeUsers: PaginatedUsersResponse;
  allDepartments: PaginatedDepartmentsResponse;
  allPermissionsGroups: PaginatedPermissionsGroupsResponse;
  allReaders: PaginatedReadersResponse;
  allReports: PaginatedReportsResponse;
  allServices: Array<Service>;
  allTags: PaginatedTagsResponse;
  allUserTypes: PaginatedUserTypesResponse;
  allUsers: PaginatedUsersResponse;
  departmentById?: Maybe<Department>;
  departments: Array<Department>;
  departmentsByKeyword: PaginatedDepartmentsResponse;
  lateActiveUsers: PaginatedUsersResponse;
  lateUsers: Array<TypeWiseUsersResponse>;
  me?: Maybe<UserWithPermissionsGroups>;
  permissionTags: Array<Scalars['String']>;
  permissionsGroupById: PermissionsGroup;
  permissionsGroups: Array<PermissionsGroup>;
  permissionsGroupsByKeyword: PaginatedPermissionsGroupsResponse;
  presentUsers: Array<TypeWiseUsersResponse>;
  readerById?: Maybe<Reader>;
  readers: Array<Reader>;
  readersByFilter: PaginatedReadersResponse;
  readersByType: Array<Reader>;
  reportById?: Maybe<ExtendedReport>;
  reportsByKeyword: PaginatedReportsResponse;
  serviceById: Service;
  servicesByKeyword: Array<Service>;
  statusLogsOfReader: PaginatedReaderStatusLogsResponse;
  tagById?: Maybe<ExtendedTag>;
  tagsByFilter: PaginatedTagsResponse;
  totalUsers: Array<TypeWiseUsersResponse>;
  userById?: Maybe<User>;
  userPastAttendanceRecords: PaginatedUserAttendanceRecordsResponse;
  userPermissionsGroups?: Maybe<Array<PermissionsGroup>>;
  userTypeById: UserType;
  userTypes: Array<UserType>;
  userTypesByKeyword: PaginatedUserTypesResponse;
  users: PaginatedUsersResponse;
  usersByDepartment: PaginatedUsersResponse;
  usersByKeyword: PaginatedUsersResponse;
  usersByType: PaginatedUsersResponse;
};


export type QueryActiveAttendanceOfUserArgs = {
  userId: Scalars['String'];
};


export type QueryActiveUsersArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
  roleType?: InputMaybe<UserRoleTypes>;
  status?: InputMaybe<UserStatus>;
  typeId?: InputMaybe<Scalars['String']>;
};


export type QueryAllDepartmentsArgs = {
  pagination: PaginatedInput;
};


export type QueryAllPermissionsGroupsArgs = {
  pagination: PaginatedInput;
};


export type QueryAllReadersArgs = {
  pagination: PaginatedInput;
};


export type QueryAllReportsArgs = {
  pagination: PaginatedInput;
};


export type QueryAllTagsArgs = {
  pagination: PaginatedInput;
};


export type QueryAllUserTypesArgs = {
  pagination: PaginatedInput;
};


export type QueryAllUsersArgs = {
  pagination: PaginatedInput;
};


export type QueryDepartmentByIdArgs = {
  departmentId: Scalars['String'];
};


export type QueryDepartmentsByKeywordArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
};


export type QueryLateActiveUsersArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
  roleType?: InputMaybe<UserRoleTypes>;
  status?: InputMaybe<UserStatus>;
  typeId?: InputMaybe<Scalars['String']>;
};


export type QueryPermissionsGroupByIdArgs = {
  permissionsGroupId: Scalars['String'];
};


export type QueryPermissionsGroupsByKeywordArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
};


export type QueryReaderByIdArgs = {
  readerId: Scalars['String'];
};


export type QueryReadersByFilterArgs = {
  filter: ReadersFilterInput;
  pagination: PaginatedInput;
};


export type QueryReadersByTypeArgs = {
  type: ReaderTypes;
};


export type QueryReportByIdArgs = {
  reportId: Scalars['String'];
};


export type QueryReportsByKeywordArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  keyword: Scalars['String'];
  pagination: PaginatedInput;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryServiceByIdArgs = {
  serviceId: Scalars['String'];
};


export type QueryServicesByKeywordArgs = {
  keyword: Scalars['String'];
};


export type QueryStatusLogsOfReaderArgs = {
  date: Scalars['DateTime'];
  pagination: PaginatedInput;
  readerId: Scalars['String'];
};


export type QueryTagByIdArgs = {
  tagId: Scalars['String'];
};


export type QueryTagsByFilterArgs = {
  filter: TagsFilterInput;
  pagination: PaginatedInput;
};


export type QueryUserByIdArgs = {
  userId: Scalars['String'];
};


export type QueryUserPastAttendanceRecordsArgs = {
  date: Scalars['DateTime'];
  pagination: PaginatedInput;
  userId: Scalars['String'];
};


export type QueryUserPermissionsGroupsArgs = {
  userId: Scalars['String'];
};


export type QueryUserTypeByIdArgs = {
  userTypeId: Scalars['String'];
};


export type QueryUserTypesByKeywordArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
};


export type QueryUsersArgs = {
  filter: UsersFilterInput;
  pagination: PaginatedInput;
};


export type QueryUsersByDepartmentArgs = {
  departmentId: Scalars['String'];
  pagination: PaginatedInput;
};


export type QueryUsersByKeywordArgs = {
  keyword: Scalars['String'];
  pagination: PaginatedInput;
  roleType?: InputMaybe<UserRoleTypes>;
  since?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<UserStatus>;
  typeId?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['DateTime']>;
};


export type QueryUsersByTypeArgs = {
  pagination: PaginatedInput;
  typeId: Scalars['String'];
};

export type Reader = {
  __typename?: 'Reader';
  _id: Scalars['String'];
  assignedAt?: Maybe<Scalars['DateTime']>;
  assignedToZoneId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
  label: Label;
  lastConnectedAt?: Maybe<Scalars['DateTime']>;
  lastConnectedEndpoint?: Maybe<Scalars['String']>;
  lastHeartbeatAt?: Maybe<Scalars['DateTime']>;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  readerDecimalId: Scalars['String'];
  readerHexId: Scalars['String'];
  type: ReaderTypes;
  updatedAt: Scalars['DateTime'];
};

export type ReaderInput = {
  label: LabelInput;
  readerDecimalId: Scalars['String'];
  type: ReaderTypes;
};

export type ReaderStatusLog = {
  __typename?: 'ReaderStatusLog';
  _id: Scalars['String'];
  connectedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  disconnectedAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  readerId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ReaderTypes {
  Indoor = 'Indoor',
  Outdoor = 'Outdoor',
  StockEnrolling = 'StockEnrolling',
  TagEnrolling = 'TagEnrolling'
}

export type ReadersFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ReaderTypes>;
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['String'];
  completeJson?: Maybe<ReportObject>;
  createdAt: Scalars['DateTime'];
  csv?: Maybe<ReportObject>;
  json?: Maybe<ReportObject>;
  label: Label;
  readerIds?: Maybe<Array<Scalars['String']>>;
  sinceDate: Scalars['DateTime'];
  status: ReportStatus;
  type: ReportTypes;
  untilDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userIds?: Maybe<Array<Scalars['String']>>;
  workingHours?: Maybe<Scalars['Float']>;
};

export type ReportObject = {
  __typename?: 'ReportObject';
  key: Scalars['String'];
  url: Scalars['String'];
};

export enum ReportStatus {
  Failed = 'Failed',
  Generated = 'Generated',
  Processing = 'Processing',
  Queued = 'Queued'
}

export enum ReportTypes {
  UserAttendance = 'UserAttendance'
}

export type Service = {
  __typename?: 'Service';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label: Label;
  lastHeartbeatAt?: Maybe<Scalars['DateTime']>;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ServiceInput = {
  key: Scalars['String'];
  label: LabelInput;
};

export type Subscription = {
  __typename?: 'Subscription';
  enrolledTagByReaderId: EnrolledTag;
  readerUpdate: Reader;
  reportUpdate: Report;
};


export type SubscriptionEnrolledTagByReaderIdArgs = {
  readerId: Scalars['String'];
};


export type SubscriptionReaderUpdateArgs = {
  readerId: Scalars['String'];
};


export type SubscriptionReportUpdateArgs = {
  reportId: Scalars['String'];
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['String'];
  assignedAt?: Maybe<Scalars['DateTime']>;
  assignedToUserId?: Maybe<Scalars['String']>;
  batteryStatus: TagBatteryStatus;
  createdAt: Scalars['DateTime'];
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  status: TagStatus;
  tagDecimalId: Scalars['String'];
  tagHexId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum TagBatteryStatus {
  Low = 'Low',
  Normal = 'Normal'
}

export enum TagStatus {
  Active = 'Active',
  Delivered = 'Delivered',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Personalized = 'Personalized',
  Unregistered = 'Unregistered',
  Virgin = 'Virgin'
}

export type TagsFilterInput = {
  batteryStatus?: InputMaybe<TagBatteryStatus>;
  keyword?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TagStatus>;
};

export type TypeWiseUsersResponse = {
  __typename?: 'TypeWiseUsersResponse';
  typeId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type UploadSignatureResponse = {
  __typename?: 'UploadSignatureResponse';
  key: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentRole?: Maybe<UserRole>;
  email?: Maybe<Email>;
  employeeId?: Maybe<Scalars['String']>;
  fcmTokens?: Maybe<Array<Scalars['String']>>;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  name: Scalars['String'];
  pastRoles?: Maybe<Array<UserRole>>;
  permissionsGroupIds?: Maybe<Array<Scalars['String']>>;
  phone?: Maybe<Phone>;
  picture?: Maybe<Picture>;
  roleType: UserRoleTypes;
  status: UserStatus;
  tagId?: Maybe<Scalars['String']>;
  typeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type UserAttendanceRecord = {
  __typename?: 'UserAttendanceRecord';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endAt: Scalars['DateTime'];
  startAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserAttendanceReportInput = {
  label: LabelInput;
  sinceDate: Scalars['DateTime'];
  untilDate: Scalars['DateTime'];
  userIds: Array<Scalars['String']>;
};

export type UserAuthResponse = {
  __typename?: 'UserAuthResponse';
  errors?: Maybe<Array<FieldError>>;
  sessionToken?: Maybe<Scalars['String']>;
  user?: Maybe<UserWithPermissionsGroups>;
};

export type UserInput = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailInput>;
  employeeId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<PhoneInput>;
  roleType: UserRoleTypes;
  typeId: Scalars['String'];
};

export type UserRole = {
  __typename?: 'UserRole';
  _id: Scalars['String'];
  assignedAt: Scalars['DateTime'];
  assignedUserIds?: Maybe<Array<Scalars['String']>>;
  departmentId: Scalars['String'];
  designation?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['DateTime']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  status: UserRoleStatus;
};

export type UserRoleInput = {
  assignedUserIds?: InputMaybe<Array<Scalars['String']>>;
  departmentId: Scalars['String'];
  designation: Scalars['String'];
  expireAt?: InputMaybe<Scalars['DateTime']>;
};

export enum UserRoleStatus {
  Active = 'Active',
  Expired = 'Expired',
  Past = 'Past'
}

export enum UserRoleTypes {
  Admin = 'Admin',
  ShortTerm = 'ShortTerm',
  Working = 'Working'
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type UserType = {
  __typename?: 'UserType';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  label: Label;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  roleType: UserRoleTypes;
  updatedAt: Scalars['DateTime'];
};

export type UserTypeInput = {
  label: LabelInput;
  roleType: UserRoleTypes;
};

export type UserWithPermissionsGroups = {
  __typename?: 'UserWithPermissionsGroups';
  _id: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currentRole?: Maybe<UserRole>;
  email?: Maybe<Email>;
  employeeId?: Maybe<Scalars['String']>;
  fcmTokens?: Maybe<Array<Scalars['String']>>;
  lastUpdatedAt: Scalars['DateTime'];
  lastUpdatedByUserId: Scalars['String'];
  name: Scalars['String'];
  pastRoles?: Maybe<Array<UserRole>>;
  permissionsGroupIds?: Maybe<Array<Scalars['String']>>;
  permissionsGroups?: Maybe<Array<PermissionsGroup>>;
  phone?: Maybe<Phone>;
  picture?: Maybe<Picture>;
  roleType: UserRoleTypes;
  status: UserStatus;
  tagId?: Maybe<Scalars['String']>;
  typeId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type UsersFilterInput = {
  departmentId?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<UserRoleTypes>;
  userTypeId?: InputMaybe<Scalars['String']>;
};

export type DepartmentFragment = { __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } };

export type EmailFragment = { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any };

export type EnrolledTagFragment = { __typename?: 'EnrolledTag', _id: string, readerId: string, tagHexId: string, tagDecimalId: string, createdAt: any, updatedAt: any };

export type ExtendedReportFragment = { __typename?: 'ExtendedReport', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, users?: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> | null, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null, lastUpdatedByUser?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null };

export type ExtendedTagFragment = { __typename?: 'ExtendedTag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null };

export type FieldErrorFragment = { __typename?: 'FieldError', field: string, error: string };

export type LabelFragment = { __typename?: 'Label', name: string, description?: string | null };

export type PermissionsGroupFragment = { __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } };

export type PictureFragment = { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null };

export type PictureObjectFragment = { __typename?: 'PictureObject', key: string, url: string, height: number, width: number };

export type ReaderFragment = { __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } };

export type ReaderStatusLogFragment = { __typename?: 'ReaderStatusLog', _id: string, readerId: string, isActive?: boolean | null, connectedAt: any, disconnectedAt?: any | null, createdAt: any, updatedAt: any };

export type ReportFragment = { __typename?: 'Report', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null };

export type ServiceFragment = { __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } };

export type TagFragment = { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any };

export type UserFragment = { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null };

export type UserAttendanceRecordFragment = { __typename?: 'UserAttendanceRecord', _id: string, userId: string, startAt: any, endAt: any, createdAt: any, updatedAt: any };

export type UserAuthResponseFragment = { __typename?: 'UserAuthResponse', sessionToken?: string | null, errors?: Array<{ __typename?: 'FieldError', field: string, error: string }> | null, user?: { __typename?: 'UserWithPermissionsGroups', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, permissionsGroupIds?: Array<string> | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, permissionsGroups?: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> | null } | null };

export type UserRoleFragment = { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null };

export type UserTypeFragment = { __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } };

export type UserWithPermissionsGroupsFragment = { __typename?: 'UserWithPermissionsGroups', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, permissionsGroupIds?: Array<string> | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, permissionsGroups?: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> | null };

export type ActivateTagOfUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ActivateTagOfUserMutation = { __typename?: 'Mutation', activateTagOfUser: { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any } };

export type ActivateUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } };

export type AssignTagMutationVariables = Exact<{
  userId: Scalars['String'];
  tagDecimalId: Scalars['String'];
}>;


export type AssignTagMutation = { __typename?: 'Mutation', assignTag: { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any } };

export type AssignUserRoleMutationVariables = Exact<{
  userId: Scalars['String'];
  input: UserRoleInput;
}>;


export type AssignUserRoleMutation = { __typename?: 'Mutation', assignUserRole: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  shouldLogOutOnOtherDevices?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type CreateDepartmentMutationVariables = Exact<{
  input: DepartmentInput;
}>;


export type CreateDepartmentMutation = { __typename?: 'Mutation', createDepartment: { __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type CreatePermissionsGroupMutationVariables = Exact<{
  input: PermissionsGroupInput;
}>;


export type CreatePermissionsGroupMutation = { __typename?: 'Mutation', createPermissionsGroup: { __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type CreateReaderMutationVariables = Exact<{
  input: ReaderInput;
}>;


export type CreateReaderMutation = { __typename?: 'Mutation', createReader: { __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type CreateServiceMutationVariables = Exact<{
  input: ServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type CreateTagMutationVariables = Exact<{
  tagDecimalId: Scalars['String'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any } };

export type CreateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } };

export type CreateUserTypeMutationVariables = Exact<{
  input: UserTypeInput;
}>;


export type CreateUserTypeMutation = { __typename?: 'Mutation', createUserType: { __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type DeactivateTagOfUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeactivateTagOfUserMutation = { __typename?: 'Mutation', deactivateTagOfUser: { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any } };

export type DeactivateUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } };

export type DeleteServiceMutationVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService: boolean };

export type ExtendUserRoleMutationVariables = Exact<{
  userId: Scalars['String'];
  expireAt: Scalars['DateTime'];
}>;


export type ExtendUserRoleMutation = { __typename?: 'Mutation', extendUserRole: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } };

export type FinishAvatarUploadMutationVariables = Exact<{
  userId: Scalars['String'];
  input: FinishUploadInput;
}>;


export type FinishAvatarUploadMutation = { __typename?: 'Mutation', finishAvatarUpload: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } };

export type FlushTagMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FlushTagMutation = { __typename?: 'Mutation', flushTag: { __typename?: 'Tag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any } };

export type GenerateUserAttendanceReportMutationVariables = Exact<{
  input: UserAttendanceReportInput;
}>;


export type GenerateUserAttendanceReportMutation = { __typename?: 'Mutation', generateUserAttendanceReport: { __typename?: 'ExtendedReport', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, users?: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> | null, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null, lastUpdatedByUser?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UserAuthResponse', sessionToken?: string | null, errors?: Array<{ __typename?: 'FieldError', field: string, error: string }> | null, user?: { __typename?: 'UserWithPermissionsGroups', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, permissionsGroupIds?: Array<string> | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, permissionsGroups?: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> | null } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RemoveCurrentUserRoleMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveCurrentUserRoleMutation = { __typename?: 'Mutation', removeCurrentUserRole: boolean };

export type SendEmailVerificationSecretCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendEmailVerificationSecretCodeMutation = { __typename?: 'Mutation', sendEmailVerificationSecretCode: boolean };

export type SignAvatarUploadMutationVariables = Exact<{
  userId: Scalars['String'];
  format: Scalars['String'];
}>;


export type SignAvatarUploadMutation = { __typename?: 'Mutation', signAvatarUpload: { __typename?: 'UploadSignatureResponse', signedUrl: string, key: string } };

export type UpdateReaderMutationVariables = Exact<{
  readerId: Scalars['String'];
  input: ReaderInput;
}>;


export type UpdateReaderMutation = { __typename?: 'Mutation', updateReader: { __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type UpdateServiceMutationVariables = Exact<{
  serviceId: Scalars['String'];
  input: ServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String'];
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } };

export type UpdateUserPermissionsGroupsMutationVariables = Exact<{
  userId: Scalars['String'];
  permissionsGroupIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateUserPermissionsGroupsMutation = { __typename?: 'Mutation', updateUserPermissionsGroups: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type VerifyEmailWithSecretCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type VerifyEmailWithSecretCodeMutation = { __typename?: 'Mutation', verifyEmailWithSecretCode: boolean };

export type ActiveAttendanceOfUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ActiveAttendanceOfUserQuery = { __typename?: 'Query', activeAttendanceOfUser?: { __typename?: 'UserAttendanceRecord', _id: string, userId: string, startAt: any, endAt: any, createdAt: any, updatedAt: any } | null };

export type ActiveUsersQueryVariables = Exact<{
  keyword: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<UserRoleTypes>;
  status?: InputMaybe<UserStatus>;
  pagination: PaginatedInput;
}>;


export type ActiveUsersQuery = { __typename?: 'Query', activeUsers: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type AllDepartmentsQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllDepartmentsQuery = { __typename?: 'Query', allDepartments: { __typename?: 'PaginatedDepartmentsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, departments: Array<{ __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type AllPermissionsGroupsQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllPermissionsGroupsQuery = { __typename?: 'Query', allPermissionsGroups: { __typename?: 'PaginatedPermissionsGroupsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, permissionsGroups: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type AllReadersQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllReadersQuery = { __typename?: 'Query', allReaders: { __typename?: 'PaginatedReadersResponse', hasNextPage: boolean, hasPrevPage: boolean, currentPage: number, readers: Array<{ __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type AllReportsQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllReportsQuery = { __typename?: 'Query', allReports: { __typename?: 'PaginatedReportsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, reports: Array<{ __typename?: 'Report', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null }> } };

export type AllServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllServicesQuery = { __typename?: 'Query', allServices: Array<{ __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type AllTagsQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllTagsQuery = { __typename?: 'Query', allTags: { __typename?: 'PaginatedTagsResponse', hasNextPage: boolean, hasPrevPage: boolean, currentPage: number, tags: Array<{ __typename?: 'ExtendedTag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null }> } };

export type AllUserTypesQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllUserTypesQuery = { __typename?: 'Query', allUserTypes: { __typename?: 'PaginatedUserTypesResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, userTypes: Array<{ __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type AllUsersQueryVariables = Exact<{
  pagination: PaginatedInput;
}>;


export type AllUsersQuery = { __typename?: 'Query', allUsers: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type DepartmentByIdQueryVariables = Exact<{
  departmentId: Scalars['String'];
}>;


export type DepartmentByIdQuery = { __typename?: 'Query', departmentById?: { __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } | null };

export type DepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type DepartmentsQuery = { __typename?: 'Query', departments: Array<{ __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type DepartmentsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  pagination: PaginatedInput;
}>;


export type DepartmentsByKeywordQuery = { __typename?: 'Query', departmentsByKeyword: { __typename?: 'PaginatedDepartmentsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, departments: Array<{ __typename?: 'Department', _id: string, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type LateActiveUsersQueryVariables = Exact<{
  keyword: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<UserRoleTypes>;
  status?: InputMaybe<UserStatus>;
  pagination: PaginatedInput;
}>;


export type LateActiveUsersQuery = { __typename?: 'Query', lateActiveUsers: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type LateUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type LateUsersQuery = { __typename?: 'Query', lateUsers: Array<{ __typename?: 'TypeWiseUsersResponse', typeId: string, userIds: Array<string> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserWithPermissionsGroups', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, permissionsGroupIds?: Array<string> | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, permissionsGroups?: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> | null } | null };

export type PermissionsGroupByIdQueryVariables = Exact<{
  permissionsGroupId: Scalars['String'];
}>;


export type PermissionsGroupByIdQuery = { __typename?: 'Query', permissionsGroupById: { __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type PermissionsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsGroupsQuery = { __typename?: 'Query', permissionsGroups: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type PermissionsGroupsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  pagination: PaginatedInput;
}>;


export type PermissionsGroupsByKeywordQuery = { __typename?: 'Query', permissionsGroupsByKeyword: { __typename?: 'PaginatedPermissionsGroupsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, permissionsGroups: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type PermissionTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionTagsQuery = { __typename?: 'Query', permissionTags: Array<string> };

export type PresentUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PresentUsersQuery = { __typename?: 'Query', presentUsers: Array<{ __typename?: 'TypeWiseUsersResponse', typeId: string, userIds: Array<string> }> };

export type ReaderByIdQueryVariables = Exact<{
  readerId: Scalars['String'];
}>;


export type ReaderByIdQuery = { __typename?: 'Query', readerById?: { __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } | null };

export type ReadersQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadersQuery = { __typename?: 'Query', readers: Array<{ __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type ReadersByFilterQueryVariables = Exact<{
  filter: ReadersFilterInput;
  pagination: PaginatedInput;
}>;


export type ReadersByFilterQuery = { __typename?: 'Query', readersByFilter: { __typename?: 'PaginatedReadersResponse', hasNextPage: boolean, hasPrevPage: boolean, currentPage: number, readers: Array<{ __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type ReadersByTypeQueryVariables = Exact<{
  type: ReaderTypes;
}>;


export type ReadersByTypeQuery = { __typename?: 'Query', readersByType: Array<{ __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type ReportByIdQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type ReportByIdQuery = { __typename?: 'Query', reportById?: { __typename?: 'ExtendedReport', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, users?: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> | null, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null, lastUpdatedByUser?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null } | null };

export type ReportsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  pagination: PaginatedInput;
}>;


export type ReportsByKeywordQuery = { __typename?: 'Query', reportsByKeyword: { __typename?: 'PaginatedReportsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, reports: Array<{ __typename?: 'Report', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null }> } };

export type ServiceByIdQueryVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type ServiceByIdQuery = { __typename?: 'Query', serviceById: { __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type ServicesByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
}>;


export type ServicesByKeywordQuery = { __typename?: 'Query', servicesByKeyword: Array<{ __typename?: 'Service', _id: string, key: string, lastHeartbeatAt?: any | null, isActive?: boolean | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type StatusLogsOfReaderQueryVariables = Exact<{
  readerId: Scalars['String'];
  date: Scalars['DateTime'];
  pagination: PaginatedInput;
}>;


export type StatusLogsOfReaderQuery = { __typename?: 'Query', statusLogsOfReader: { __typename?: 'PaginatedReaderStatusLogsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, readerStatusLogs: Array<{ __typename?: 'ReaderStatusLog', _id: string, readerId: string, isActive?: boolean | null, connectedAt: any, disconnectedAt?: any | null, createdAt: any, updatedAt: any }> } };

export type TagByIdQueryVariables = Exact<{
  tagId: Scalars['String'];
}>;


export type TagByIdQuery = { __typename?: 'Query', tagById?: { __typename?: 'ExtendedTag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null } | null };

export type TagsByFilterQueryVariables = Exact<{
  filter: TagsFilterInput;
  pagination: PaginatedInput;
}>;


export type TagsByFilterQuery = { __typename?: 'Query', tagsByFilter: { __typename?: 'PaginatedTagsResponse', hasNextPage: boolean, hasPrevPage: boolean, currentPage: number, tags: Array<{ __typename?: 'ExtendedTag', _id: string, tagHexId: string, tagDecimalId: string, status: TagStatus, batteryStatus: TagBatteryStatus, assignedToUserId?: string | null, assignedAt?: any | null, createdAt: any, updatedAt: any, user?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null }> } };

export type TotalUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalUsersQuery = { __typename?: 'Query', totalUsers: Array<{ __typename?: 'TypeWiseUsersResponse', typeId: string, userIds: Array<string> }> };

export type UserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null } | null };

export type UserPastAttendanceRecordsQueryVariables = Exact<{
  userId: Scalars['String'];
  date: Scalars['DateTime'];
  pagination: PaginatedInput;
}>;


export type UserPastAttendanceRecordsQuery = { __typename?: 'Query', userPastAttendanceRecords: { __typename?: 'PaginatedUserAttendanceRecordsResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, userAttendanceRecords: Array<{ __typename?: 'UserAttendanceRecord', _id: string, userId: string, startAt: any, endAt: any, createdAt: any, updatedAt: any }> } };

export type UserPermissionsGroupsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserPermissionsGroupsQuery = { __typename?: 'Query', userPermissionsGroups?: Array<{ __typename?: 'PermissionsGroup', _id: string, tags: Array<string>, isPrivateToAdmin?: boolean | null, label: { __typename?: 'Label', name: string, description?: string | null } }> | null };

export type UserTypeByIdQueryVariables = Exact<{
  userTypeId: Scalars['String'];
}>;


export type UserTypeByIdQuery = { __typename?: 'Query', userTypeById: { __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type UserTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTypesQuery = { __typename?: 'Query', userTypes: Array<{ __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } }> };

export type UserTypesByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  pagination: PaginatedInput;
}>;


export type UserTypesByKeywordQuery = { __typename?: 'Query', userTypesByKeyword: { __typename?: 'PaginatedUserTypesResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, userTypes: Array<{ __typename?: 'UserType', _id: string, roleType: UserRoleTypes, label: { __typename?: 'Label', name: string, description?: string | null } }> } };

export type UsersQueryVariables = Exact<{
  filter: UsersFilterInput;
  pagination: PaginatedInput;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type UsersByDepartmentQueryVariables = Exact<{
  departmentId: Scalars['String'];
  pagination: PaginatedInput;
}>;


export type UsersByDepartmentQuery = { __typename?: 'Query', usersByDepartment: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type UsersByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  typeId?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<UserRoleTypes>;
  status?: InputMaybe<UserStatus>;
  since?: InputMaybe<Scalars['DateTime']>;
  until?: InputMaybe<Scalars['DateTime']>;
  pagination: PaginatedInput;
}>;


export type UsersByKeywordQuery = { __typename?: 'Query', usersByKeyword: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type UsersByTypeQueryVariables = Exact<{
  typeId: Scalars['String'];
  pagination: PaginatedInput;
}>;


export type UsersByTypeQuery = { __typename?: 'Query', usersByType: { __typename?: 'PaginatedUsersResponse', hasPrevPage: boolean, hasNextPage: boolean, currentPage: number, users: Array<{ __typename?: 'User', _id: string, name: string, username: string, address?: string | null, roleType: UserRoleTypes, typeId: string, employeeId?: string | null, tagId?: string | null, status: UserStatus, createdAt: any, updatedAt: any, phone?: { __typename?: 'Phone', countryCode: string, number: string } | null, email?: { __typename?: 'Email', address: string, isVerified: boolean, verifiedAt?: any | null, createdAt: any, updatedAt: any } | null, picture?: { __typename?: 'Picture', original: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number }, variants?: { __typename?: 'PictureVariants', small?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, medium?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, large?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null, thumbnail?: { __typename?: 'PictureObject', key: string, url: string, height: number, width: number } | null } | null } | null, currentRole?: { __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null } | null, pastRoles?: Array<{ __typename?: 'UserRole', _id: string, designation?: string | null, departmentId: string, expireAt?: any | null, status: UserRoleStatus, assignedAt: any, removedAt?: any | null }> | null }> } };

export type EnrolledTagByReaderIdSubscriptionVariables = Exact<{
  readerId: Scalars['String'];
}>;


export type EnrolledTagByReaderIdSubscription = { __typename?: 'Subscription', enrolledTagByReaderId: { __typename?: 'EnrolledTag', _id: string, readerId: string, tagHexId: string, tagDecimalId: string, createdAt: any, updatedAt: any } };

export type ReaderUpdateSubscriptionVariables = Exact<{
  readerId: Scalars['String'];
}>;


export type ReaderUpdateSubscription = { __typename?: 'Subscription', readerUpdate: { __typename?: 'Reader', _id: string, type: ReaderTypes, readerHexId: string, readerDecimalId: string, assignedToZoneId?: string | null, assignedAt?: any | null, isActive?: boolean | null, lastConnectedEndpoint?: string | null, lastConnectedAt?: any | null, lastHeartbeatAt?: any | null, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null } } };

export type ReportUpdateSubscriptionVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type ReportUpdateSubscription = { __typename?: 'Subscription', reportUpdate: { __typename?: 'Report', _id: string, type: ReportTypes, userIds?: Array<string> | null, sinceDate: any, untilDate: any, status: ReportStatus, createdAt: any, updatedAt: any, label: { __typename?: 'Label', name: string, description?: string | null }, completeJson?: { __typename?: 'ReportObject', key: string, url: string } | null, json?: { __typename?: 'ReportObject', key: string, url: string } | null, csv?: { __typename?: 'ReportObject', key: string, url: string } | null } };

export const LabelFragmentDoc = gql`
    fragment Label on Label {
  name
  description
}
    `;
export const DepartmentFragmentDoc = gql`
    fragment Department on Department {
  _id
  label {
    ...Label
  }
  createdAt
  updatedAt
}
    ${LabelFragmentDoc}`;
export const EnrolledTagFragmentDoc = gql`
    fragment EnrolledTag on EnrolledTag {
  _id
  readerId
  tagHexId
  tagDecimalId
  createdAt
  updatedAt
}
    `;
export const EmailFragmentDoc = gql`
    fragment Email on Email {
  address
  isVerified
  verifiedAt
  createdAt
  updatedAt
}
    `;
export const PictureObjectFragmentDoc = gql`
    fragment PictureObject on PictureObject {
  key
  url
  height
  width
}
    `;
export const PictureFragmentDoc = gql`
    fragment Picture on Picture {
  original {
    ...PictureObject
  }
  variants {
    small {
      ...PictureObject
    }
    medium {
      ...PictureObject
    }
    large {
      ...PictureObject
    }
    thumbnail {
      ...PictureObject
    }
  }
}
    ${PictureObjectFragmentDoc}`;
export const UserRoleFragmentDoc = gql`
    fragment UserRole on UserRole {
  _id
  designation
  departmentId
  expireAt
  status
  assignedAt
  removedAt
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  _id
  name
  phone {
    countryCode
    number
  }
  email {
    ...Email
  }
  username
  address
  picture {
    ...Picture
  }
  roleType
  typeId
  employeeId
  tagId
  status
  currentRole {
    ...UserRole
  }
  pastRoles {
    ...UserRole
  }
  createdAt
  updatedAt
}
    ${EmailFragmentDoc}
${PictureFragmentDoc}
${UserRoleFragmentDoc}`;
export const ExtendedReportFragmentDoc = gql`
    fragment ExtendedReport on ExtendedReport {
  _id
  label {
    ...Label
  }
  type
  userIds
  users {
    ...User
  }
  sinceDate
  untilDate
  status
  completeJson {
    key
    url
  }
  json {
    key
    url
  }
  csv {
    key
    url
  }
  lastUpdatedByUser {
    ...User
  }
  createdAt
  updatedAt
}
    ${LabelFragmentDoc}
${UserFragmentDoc}`;
export const ExtendedTagFragmentDoc = gql`
    fragment ExtendedTag on ExtendedTag {
  _id
  tagHexId
  tagDecimalId
  status
  batteryStatus
  assignedToUserId
  user {
    ...User
  }
  assignedAt
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const ReaderFragmentDoc = gql`
    fragment Reader on Reader {
  _id
  label {
    ...Label
  }
  type
  readerHexId
  readerDecimalId
  assignedToZoneId
  assignedAt
  isActive
  lastConnectedEndpoint
  lastConnectedAt
  lastHeartbeatAt
  createdAt
  updatedAt
}
    ${LabelFragmentDoc}`;
export const ReaderStatusLogFragmentDoc = gql`
    fragment ReaderStatusLog on ReaderStatusLog {
  _id
  readerId
  isActive
  connectedAt
  disconnectedAt
  createdAt
  updatedAt
}
    `;
export const ReportFragmentDoc = gql`
    fragment Report on Report {
  _id
  label {
    ...Label
  }
  type
  userIds
  sinceDate
  untilDate
  status
  completeJson {
    key
    url
  }
  json {
    key
    url
  }
  csv {
    key
    url
  }
  createdAt
  updatedAt
}
    ${LabelFragmentDoc}`;
export const ServiceFragmentDoc = gql`
    fragment Service on Service {
  _id
  key
  label {
    ...Label
  }
  lastHeartbeatAt
  isActive
  createdAt
  updatedAt
}
    ${LabelFragmentDoc}`;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  _id
  tagHexId
  tagDecimalId
  status
  batteryStatus
  assignedToUserId
  assignedAt
  createdAt
  updatedAt
}
    `;
export const UserAttendanceRecordFragmentDoc = gql`
    fragment UserAttendanceRecord on UserAttendanceRecord {
  _id
  userId
  startAt
  endAt
  createdAt
  updatedAt
}
    `;
export const FieldErrorFragmentDoc = gql`
    fragment FieldError on FieldError {
  field
  error
}
    `;
export const PermissionsGroupFragmentDoc = gql`
    fragment PermissionsGroup on PermissionsGroup {
  _id
  tags
  label {
    ...Label
  }
  isPrivateToAdmin
}
    ${LabelFragmentDoc}`;
export const UserWithPermissionsGroupsFragmentDoc = gql`
    fragment UserWithPermissionsGroups on UserWithPermissionsGroups {
  _id
  name
  phone {
    countryCode
    number
  }
  email {
    ...Email
  }
  username
  address
  picture {
    ...Picture
  }
  roleType
  typeId
  employeeId
  tagId
  permissionsGroupIds
  permissionsGroups {
    ...PermissionsGroup
  }
  status
  createdAt
  updatedAt
}
    ${EmailFragmentDoc}
${PictureFragmentDoc}
${PermissionsGroupFragmentDoc}`;
export const UserAuthResponseFragmentDoc = gql`
    fragment UserAuthResponse on UserAuthResponse {
  errors {
    ...FieldError
  }
  user {
    ...UserWithPermissionsGroups
  }
  sessionToken
}
    ${FieldErrorFragmentDoc}
${UserWithPermissionsGroupsFragmentDoc}`;
export const UserTypeFragmentDoc = gql`
    fragment UserType on UserType {
  _id
  label {
    ...Label
  }
  roleType
}
    ${LabelFragmentDoc}`;
export const ActivateTagOfUserDocument = gql`
    mutation activateTagOfUser($userId: String!) {
  activateTagOfUser(userId: $userId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useActivateTagOfUserMutation() {
  return Urql.useMutation<ActivateTagOfUserMutation, ActivateTagOfUserMutationVariables>(ActivateTagOfUserDocument);
};
export const ActivateUserDocument = gql`
    mutation ActivateUser($userId: String!) {
  activateUser(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useActivateUserMutation() {
  return Urql.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument);
};
export const AssignTagDocument = gql`
    mutation AssignTag($userId: String!, $tagDecimalId: String!) {
  assignTag(userId: $userId, tagDecimalId: $tagDecimalId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useAssignTagMutation() {
  return Urql.useMutation<AssignTagMutation, AssignTagMutationVariables>(AssignTagDocument);
};
export const AssignUserRoleDocument = gql`
    mutation assignUserRole($userId: String!, $input: UserRoleInput!) {
  assignUserRole(userId: $userId, input: $input) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;

export function useAssignUserRoleMutation() {
  return Urql.useMutation<AssignUserRoleMutation, AssignUserRoleMutationVariables>(AssignUserRoleDocument);
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $newPassword: String!, $shouldLogOutOnOtherDevices: Boolean) {
  changePassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
    shouldLogOutOnOtherDevices: $shouldLogOutOnOtherDevices
  )
}
    `;

export function useChangePasswordMutation() {
  return Urql.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument);
};
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: DepartmentInput!) {
  createDepartment(input: $input) {
    ...Department
  }
}
    ${DepartmentFragmentDoc}`;

export function useCreateDepartmentMutation() {
  return Urql.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument);
};
export const CreatePermissionsGroupDocument = gql`
    mutation CreatePermissionsGroup($input: PermissionsGroupInput!) {
  createPermissionsGroup(input: $input) {
    ...PermissionsGroup
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function useCreatePermissionsGroupMutation() {
  return Urql.useMutation<CreatePermissionsGroupMutation, CreatePermissionsGroupMutationVariables>(CreatePermissionsGroupDocument);
};
export const CreateReaderDocument = gql`
    mutation CreateReader($input: ReaderInput!) {
  createReader(input: $input) {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useCreateReaderMutation() {
  return Urql.useMutation<CreateReaderMutation, CreateReaderMutationVariables>(CreateReaderDocument);
};
export const CreateServiceDocument = gql`
    mutation createService($input: ServiceInput!) {
  createService(input: $input) {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

export function useCreateServiceMutation() {
  return Urql.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument);
};
export const CreateTagDocument = gql`
    mutation CreateTag($tagDecimalId: String!) {
  createTag(tagDecimalId: $tagDecimalId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useCreateTagMutation() {
  return Urql.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument);
};
export const CreateUserDocument = gql`
    mutation CreateUser($input: UserInput!) {
  createUser(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const CreateUserTypeDocument = gql`
    mutation CreateUserType($input: UserTypeInput!) {
  createUserType(input: $input) {
    ...UserType
  }
}
    ${UserTypeFragmentDoc}`;

export function useCreateUserTypeMutation() {
  return Urql.useMutation<CreateUserTypeMutation, CreateUserTypeMutationVariables>(CreateUserTypeDocument);
};
export const DeactivateTagOfUserDocument = gql`
    mutation deactivateTagOfUser($userId: String!) {
  deactivateTagOfUser(userId: $userId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useDeactivateTagOfUserMutation() {
  return Urql.useMutation<DeactivateTagOfUserMutation, DeactivateTagOfUserMutationVariables>(DeactivateTagOfUserDocument);
};
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($userId: String!) {
  deactivateUser(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useDeactivateUserMutation() {
  return Urql.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument);
};
export const DeleteServiceDocument = gql`
    mutation deleteService($serviceId: String!) {
  deleteService(serviceId: $serviceId)
}
    `;

export function useDeleteServiceMutation() {
  return Urql.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument);
};
export const ExtendUserRoleDocument = gql`
    mutation extendUserRole($userId: String!, $expireAt: DateTime!) {
  extendUserRole(userId: $userId, expireAt: $expireAt) {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;

export function useExtendUserRoleMutation() {
  return Urql.useMutation<ExtendUserRoleMutation, ExtendUserRoleMutationVariables>(ExtendUserRoleDocument);
};
export const FinishAvatarUploadDocument = gql`
    mutation FinishAvatarUpload($userId: String!, $input: FinishUploadInput!) {
  finishAvatarUpload(userId: $userId, input: $input) {
    ...Picture
  }
}
    ${PictureFragmentDoc}`;

export function useFinishAvatarUploadMutation() {
  return Urql.useMutation<FinishAvatarUploadMutation, FinishAvatarUploadMutationVariables>(FinishAvatarUploadDocument);
};
export const FlushTagDocument = gql`
    mutation flushTag($userId: String!) {
  flushTag(userId: $userId) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useFlushTagMutation() {
  return Urql.useMutation<FlushTagMutation, FlushTagMutationVariables>(FlushTagDocument);
};
export const GenerateUserAttendanceReportDocument = gql`
    mutation generateUserAttendanceReport($input: UserAttendanceReportInput!) {
  generateUserAttendanceReport(input: $input) {
    ...ExtendedReport
  }
}
    ${ExtendedReportFragmentDoc}`;

export function useGenerateUserAttendanceReportMutation() {
  return Urql.useMutation<GenerateUserAttendanceReportMutation, GenerateUserAttendanceReportMutationVariables>(GenerateUserAttendanceReportDocument);
};
export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    ...UserAuthResponse
  }
}
    ${UserAuthResponseFragmentDoc}`;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const RemoveCurrentUserRoleDocument = gql`
    mutation removeCurrentUserRole($userId: String!) {
  removeCurrentUserRole(userId: $userId)
}
    `;

export function useRemoveCurrentUserRoleMutation() {
  return Urql.useMutation<RemoveCurrentUserRoleMutation, RemoveCurrentUserRoleMutationVariables>(RemoveCurrentUserRoleDocument);
};
export const SendEmailVerificationSecretCodeDocument = gql`
    mutation sendEmailVerificationSecretCode {
  sendEmailVerificationSecretCode
}
    `;

export function useSendEmailVerificationSecretCodeMutation() {
  return Urql.useMutation<SendEmailVerificationSecretCodeMutation, SendEmailVerificationSecretCodeMutationVariables>(SendEmailVerificationSecretCodeDocument);
};
export const SignAvatarUploadDocument = gql`
    mutation SignAvatarUpload($userId: String!, $format: String!) {
  signAvatarUpload(userId: $userId, format: $format) {
    signedUrl
    key
  }
}
    `;

export function useSignAvatarUploadMutation() {
  return Urql.useMutation<SignAvatarUploadMutation, SignAvatarUploadMutationVariables>(SignAvatarUploadDocument);
};
export const UpdateReaderDocument = gql`
    mutation updateReader($readerId: String!, $input: ReaderInput!) {
  updateReader(readerId: $readerId, input: $input) {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useUpdateReaderMutation() {
  return Urql.useMutation<UpdateReaderMutation, UpdateReaderMutationVariables>(UpdateReaderDocument);
};
export const UpdateServiceDocument = gql`
    mutation updateService($serviceId: String!, $input: ServiceInput!) {
  updateService(serviceId: $serviceId, input: $input) {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

export function useUpdateServiceMutation() {
  return Urql.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument);
};
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: String!, $input: UserInput!) {
  updateUser(userId: $userId, input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const UpdateUserPermissionsGroupsDocument = gql`
    mutation updateUserPermissionsGroups($userId: String!, $permissionsGroupIds: [String!]!) {
  updateUserPermissionsGroups(
    userId: $userId
    permissionsGroupIds: $permissionsGroupIds
  ) {
    ...PermissionsGroup
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function useUpdateUserPermissionsGroupsMutation() {
  return Urql.useMutation<UpdateUserPermissionsGroupsMutation, UpdateUserPermissionsGroupsMutationVariables>(UpdateUserPermissionsGroupsDocument);
};
export const VerifyEmailWithSecretCodeDocument = gql`
    mutation verifyEmailWithSecretCode($code: String!) {
  verifyEmailWithSecretCode(code: $code)
}
    `;

export function useVerifyEmailWithSecretCodeMutation() {
  return Urql.useMutation<VerifyEmailWithSecretCodeMutation, VerifyEmailWithSecretCodeMutationVariables>(VerifyEmailWithSecretCodeDocument);
};
export const ActiveAttendanceOfUserDocument = gql`
    query activeAttendanceOfUser($userId: String!) {
  activeAttendanceOfUser(userId: $userId) {
    ...UserAttendanceRecord
  }
}
    ${UserAttendanceRecordFragmentDoc}`;

export function useActiveAttendanceOfUserQuery(options: Omit<Urql.UseQueryArgs<ActiveAttendanceOfUserQueryVariables>, 'query'>) {
  return Urql.useQuery<ActiveAttendanceOfUserQuery, ActiveAttendanceOfUserQueryVariables>({ query: ActiveAttendanceOfUserDocument, ...options });
};
export const ActiveUsersDocument = gql`
    query ActiveUsers($keyword: String!, $typeId: String, $roleType: UserRoleTypes, $status: UserStatus, $pagination: PaginatedInput!) {
  activeUsers(
    keyword: $keyword
    typeId: $typeId
    roleType: $roleType
    status: $status
    pagination: $pagination
  ) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useActiveUsersQuery(options: Omit<Urql.UseQueryArgs<ActiveUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<ActiveUsersQuery, ActiveUsersQueryVariables>({ query: ActiveUsersDocument, ...options });
};
export const AllDepartmentsDocument = gql`
    query allDepartments($pagination: PaginatedInput!) {
  allDepartments(pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    departments {
      ...Department
    }
  }
}
    ${DepartmentFragmentDoc}`;

export function useAllDepartmentsQuery(options: Omit<Urql.UseQueryArgs<AllDepartmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllDepartmentsQuery, AllDepartmentsQueryVariables>({ query: AllDepartmentsDocument, ...options });
};
export const AllPermissionsGroupsDocument = gql`
    query AllPermissionsGroups($pagination: PaginatedInput!) {
  allPermissionsGroups(pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    permissionsGroups {
      ...PermissionsGroup
    }
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function useAllPermissionsGroupsQuery(options: Omit<Urql.UseQueryArgs<AllPermissionsGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllPermissionsGroupsQuery, AllPermissionsGroupsQueryVariables>({ query: AllPermissionsGroupsDocument, ...options });
};
export const AllReadersDocument = gql`
    query AllReaders($pagination: PaginatedInput!) {
  allReaders(pagination: $pagination) {
    hasNextPage
    hasPrevPage
    currentPage
    readers {
      ...Reader
    }
  }
}
    ${ReaderFragmentDoc}`;

export function useAllReadersQuery(options: Omit<Urql.UseQueryArgs<AllReadersQueryVariables>, 'query'>) {
  return Urql.useQuery<AllReadersQuery, AllReadersQueryVariables>({ query: AllReadersDocument, ...options });
};
export const AllReportsDocument = gql`
    query AllReports($pagination: PaginatedInput!) {
  allReports(pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    reports {
      ...Report
    }
  }
}
    ${ReportFragmentDoc}`;

export function useAllReportsQuery(options: Omit<Urql.UseQueryArgs<AllReportsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllReportsQuery, AllReportsQueryVariables>({ query: AllReportsDocument, ...options });
};
export const AllServicesDocument = gql`
    query allServices {
  allServices {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

export function useAllServicesQuery(options?: Omit<Urql.UseQueryArgs<AllServicesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllServicesQuery, AllServicesQueryVariables>({ query: AllServicesDocument, ...options });
};
export const AllTagsDocument = gql`
    query AllTags($pagination: PaginatedInput!) {
  allTags(pagination: $pagination) {
    hasNextPage
    hasPrevPage
    currentPage
    tags {
      ...ExtendedTag
    }
  }
}
    ${ExtendedTagFragmentDoc}`;

export function useAllTagsQuery(options: Omit<Urql.UseQueryArgs<AllTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTagsQuery, AllTagsQueryVariables>({ query: AllTagsDocument, ...options });
};
export const AllUserTypesDocument = gql`
    query AllUserTypes($pagination: PaginatedInput!) {
  allUserTypes(pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    userTypes {
      ...UserType
    }
  }
}
    ${UserTypeFragmentDoc}`;

export function useAllUserTypesQuery(options: Omit<Urql.UseQueryArgs<AllUserTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUserTypesQuery, AllUserTypesQueryVariables>({ query: AllUserTypesDocument, ...options });
};
export const AllUsersDocument = gql`
    query AllUsers($pagination: PaginatedInput!) {
  allUsers(pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useAllUsersQuery(options: Omit<Urql.UseQueryArgs<AllUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUsersQuery, AllUsersQueryVariables>({ query: AllUsersDocument, ...options });
};
export const DepartmentByIdDocument = gql`
    query DepartmentById($departmentId: String!) {
  departmentById(departmentId: $departmentId) {
    ...Department
  }
}
    ${DepartmentFragmentDoc}`;

export function useDepartmentByIdQuery(options: Omit<Urql.UseQueryArgs<DepartmentByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentByIdQuery, DepartmentByIdQueryVariables>({ query: DepartmentByIdDocument, ...options });
};
export const DepartmentsDocument = gql`
    query Departments {
  departments {
    ...Department
  }
}
    ${DepartmentFragmentDoc}`;

export function useDepartmentsQuery(options?: Omit<Urql.UseQueryArgs<DepartmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentsQuery, DepartmentsQueryVariables>({ query: DepartmentsDocument, ...options });
};
export const DepartmentsByKeywordDocument = gql`
    query DepartmentsByKeyword($keyword: String!, $pagination: PaginatedInput!) {
  departmentsByKeyword(keyword: $keyword, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    departments {
      ...Department
    }
  }
}
    ${DepartmentFragmentDoc}`;

export function useDepartmentsByKeywordQuery(options: Omit<Urql.UseQueryArgs<DepartmentsByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<DepartmentsByKeywordQuery, DepartmentsByKeywordQueryVariables>({ query: DepartmentsByKeywordDocument, ...options });
};
export const LateActiveUsersDocument = gql`
    query LateActiveUsers($keyword: String!, $typeId: String, $roleType: UserRoleTypes, $status: UserStatus, $pagination: PaginatedInput!) {
  lateActiveUsers(
    keyword: $keyword
    typeId: $typeId
    roleType: $roleType
    status: $status
    pagination: $pagination
  ) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useLateActiveUsersQuery(options: Omit<Urql.UseQueryArgs<LateActiveUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<LateActiveUsersQuery, LateActiveUsersQueryVariables>({ query: LateActiveUsersDocument, ...options });
};
export const LateUsersDocument = gql`
    query lateUsers {
  lateUsers {
    typeId
    userIds
  }
}
    `;

export function useLateUsersQuery(options?: Omit<Urql.UseQueryArgs<LateUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<LateUsersQuery, LateUsersQueryVariables>({ query: LateUsersDocument, ...options });
};
export const MeDocument = gql`
    query Me {
  me {
    ...UserWithPermissionsGroups
  }
}
    ${UserWithPermissionsGroupsFragmentDoc}`;

export function useMeQuery(options?: Omit<Urql.UseQueryArgs<MeQueryVariables>, 'query'>) {
  return Urql.useQuery<MeQuery, MeQueryVariables>({ query: MeDocument, ...options });
};
export const PermissionsGroupByIdDocument = gql`
    query PermissionsGroupById($permissionsGroupId: String!) {
  permissionsGroupById(permissionsGroupId: $permissionsGroupId) {
    ...PermissionsGroup
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function usePermissionsGroupByIdQuery(options: Omit<Urql.UseQueryArgs<PermissionsGroupByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionsGroupByIdQuery, PermissionsGroupByIdQueryVariables>({ query: PermissionsGroupByIdDocument, ...options });
};
export const PermissionsGroupsDocument = gql`
    query PermissionsGroups {
  permissionsGroups {
    ...PermissionsGroup
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function usePermissionsGroupsQuery(options?: Omit<Urql.UseQueryArgs<PermissionsGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionsGroupsQuery, PermissionsGroupsQueryVariables>({ query: PermissionsGroupsDocument, ...options });
};
export const PermissionsGroupsByKeywordDocument = gql`
    query PermissionsGroupsByKeyword($keyword: String!, $pagination: PaginatedInput!) {
  permissionsGroupsByKeyword(keyword: $keyword, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    permissionsGroups {
      ...PermissionsGroup
    }
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function usePermissionsGroupsByKeywordQuery(options: Omit<Urql.UseQueryArgs<PermissionsGroupsByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionsGroupsByKeywordQuery, PermissionsGroupsByKeywordQueryVariables>({ query: PermissionsGroupsByKeywordDocument, ...options });
};
export const PermissionTagsDocument = gql`
    query PermissionTags {
  permissionTags
}
    `;

export function usePermissionTagsQuery(options?: Omit<Urql.UseQueryArgs<PermissionTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionTagsQuery, PermissionTagsQueryVariables>({ query: PermissionTagsDocument, ...options });
};
export const PresentUsersDocument = gql`
    query presentUsers {
  presentUsers {
    typeId
    userIds
  }
}
    `;

export function usePresentUsersQuery(options?: Omit<Urql.UseQueryArgs<PresentUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<PresentUsersQuery, PresentUsersQueryVariables>({ query: PresentUsersDocument, ...options });
};
export const ReaderByIdDocument = gql`
    query ReaderById($readerId: String!) {
  readerById(readerId: $readerId) {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useReaderByIdQuery(options: Omit<Urql.UseQueryArgs<ReaderByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ReaderByIdQuery, ReaderByIdQueryVariables>({ query: ReaderByIdDocument, ...options });
};
export const ReadersDocument = gql`
    query readers {
  readers {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useReadersQuery(options?: Omit<Urql.UseQueryArgs<ReadersQueryVariables>, 'query'>) {
  return Urql.useQuery<ReadersQuery, ReadersQueryVariables>({ query: ReadersDocument, ...options });
};
export const ReadersByFilterDocument = gql`
    query ReadersByFilter($filter: ReadersFilterInput!, $pagination: PaginatedInput!) {
  readersByFilter(filter: $filter, pagination: $pagination) {
    hasNextPage
    hasPrevPage
    currentPage
    readers {
      ...Reader
    }
  }
}
    ${ReaderFragmentDoc}`;

export function useReadersByFilterQuery(options: Omit<Urql.UseQueryArgs<ReadersByFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<ReadersByFilterQuery, ReadersByFilterQueryVariables>({ query: ReadersByFilterDocument, ...options });
};
export const ReadersByTypeDocument = gql`
    query ReadersByType($type: ReaderTypes!) {
  readersByType(type: $type) {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useReadersByTypeQuery(options: Omit<Urql.UseQueryArgs<ReadersByTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<ReadersByTypeQuery, ReadersByTypeQueryVariables>({ query: ReadersByTypeDocument, ...options });
};
export const ReportByIdDocument = gql`
    query ReportById($reportId: String!) {
  reportById(reportId: $reportId) {
    ...ExtendedReport
  }
}
    ${ExtendedReportFragmentDoc}`;

export function useReportByIdQuery(options: Omit<Urql.UseQueryArgs<ReportByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportByIdQuery, ReportByIdQueryVariables>({ query: ReportByIdDocument, ...options });
};
export const ReportsByKeywordDocument = gql`
    query ReportsByKeyword($keyword: String!, $type: String, $status: String, $startDate: DateTime, $endDate: DateTime, $pagination: PaginatedInput!) {
  reportsByKeyword(
    keyword: $keyword
    type: $type
    status: $status
    startDate: $startDate
    endDate: $endDate
    pagination: $pagination
  ) {
    hasPrevPage
    hasNextPage
    currentPage
    reports {
      ...Report
    }
  }
}
    ${ReportFragmentDoc}`;

export function useReportsByKeywordQuery(options: Omit<Urql.UseQueryArgs<ReportsByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportsByKeywordQuery, ReportsByKeywordQueryVariables>({ query: ReportsByKeywordDocument, ...options });
};
export const ServiceByIdDocument = gql`
    query serviceById($serviceId: String!) {
  serviceById(serviceId: $serviceId) {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

export function useServiceByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceByIdQuery, ServiceByIdQueryVariables>({ query: ServiceByIdDocument, ...options });
};
export const ServicesByKeywordDocument = gql`
    query servicesByKeyword($keyword: String!) {
  servicesByKeyword(keyword: $keyword) {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;

export function useServicesByKeywordQuery(options: Omit<Urql.UseQueryArgs<ServicesByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<ServicesByKeywordQuery, ServicesByKeywordQueryVariables>({ query: ServicesByKeywordDocument, ...options });
};
export const StatusLogsOfReaderDocument = gql`
    query statusLogsOfReader($readerId: String!, $date: DateTime!, $pagination: PaginatedInput!) {
  statusLogsOfReader(readerId: $readerId, date: $date, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    readerStatusLogs {
      ...ReaderStatusLog
    }
  }
}
    ${ReaderStatusLogFragmentDoc}`;

export function useStatusLogsOfReaderQuery(options: Omit<Urql.UseQueryArgs<StatusLogsOfReaderQueryVariables>, 'query'>) {
  return Urql.useQuery<StatusLogsOfReaderQuery, StatusLogsOfReaderQueryVariables>({ query: StatusLogsOfReaderDocument, ...options });
};
export const TagByIdDocument = gql`
    query TagById($tagId: String!) {
  tagById(tagId: $tagId) {
    ...ExtendedTag
  }
}
    ${ExtendedTagFragmentDoc}`;

export function useTagByIdQuery(options: Omit<Urql.UseQueryArgs<TagByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TagByIdQuery, TagByIdQueryVariables>({ query: TagByIdDocument, ...options });
};
export const TagsByFilterDocument = gql`
    query TagsByFilter($filter: TagsFilterInput!, $pagination: PaginatedInput!) {
  tagsByFilter(filter: $filter, pagination: $pagination) {
    hasNextPage
    hasPrevPage
    currentPage
    tags {
      ...ExtendedTag
    }
  }
}
    ${ExtendedTagFragmentDoc}`;

export function useTagsByFilterQuery(options: Omit<Urql.UseQueryArgs<TagsByFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<TagsByFilterQuery, TagsByFilterQueryVariables>({ query: TagsByFilterDocument, ...options });
};
export const TotalUsersDocument = gql`
    query totalUsers {
  totalUsers {
    typeId
    userIds
  }
}
    `;

export function useTotalUsersQuery(options?: Omit<Urql.UseQueryArgs<TotalUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<TotalUsersQuery, TotalUsersQueryVariables>({ query: TotalUsersDocument, ...options });
};
export const UserByIdDocument = gql`
    query UserById($userId: String!) {
  userById(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUserByIdQuery(options: Omit<Urql.UseQueryArgs<UserByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UserByIdQuery, UserByIdQueryVariables>({ query: UserByIdDocument, ...options });
};
export const UserPastAttendanceRecordsDocument = gql`
    query userPastAttendanceRecords($userId: String!, $date: DateTime!, $pagination: PaginatedInput!) {
  userPastAttendanceRecords(userId: $userId, date: $date, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    userAttendanceRecords {
      ...UserAttendanceRecord
    }
  }
}
    ${UserAttendanceRecordFragmentDoc}`;

export function useUserPastAttendanceRecordsQuery(options: Omit<Urql.UseQueryArgs<UserPastAttendanceRecordsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserPastAttendanceRecordsQuery, UserPastAttendanceRecordsQueryVariables>({ query: UserPastAttendanceRecordsDocument, ...options });
};
export const UserPermissionsGroupsDocument = gql`
    query UserPermissionsGroups($userId: String!) {
  userPermissionsGroups(userId: $userId) {
    ...PermissionsGroup
  }
}
    ${PermissionsGroupFragmentDoc}`;

export function useUserPermissionsGroupsQuery(options: Omit<Urql.UseQueryArgs<UserPermissionsGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserPermissionsGroupsQuery, UserPermissionsGroupsQueryVariables>({ query: UserPermissionsGroupsDocument, ...options });
};
export const UserTypeByIdDocument = gql`
    query UserTypeById($userTypeId: String!) {
  userTypeById(userTypeId: $userTypeId) {
    ...UserType
  }
}
    ${UserTypeFragmentDoc}`;

export function useUserTypeByIdQuery(options: Omit<Urql.UseQueryArgs<UserTypeByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<UserTypeByIdQuery, UserTypeByIdQueryVariables>({ query: UserTypeByIdDocument, ...options });
};
export const UserTypesDocument = gql`
    query UserTypes {
  userTypes {
    ...UserType
  }
}
    ${UserTypeFragmentDoc}`;

export function useUserTypesQuery(options?: Omit<Urql.UseQueryArgs<UserTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<UserTypesQuery, UserTypesQueryVariables>({ query: UserTypesDocument, ...options });
};
export const UserTypesByKeywordDocument = gql`
    query UserTypesByKeyword($keyword: String!, $pagination: PaginatedInput!) {
  userTypesByKeyword(keyword: $keyword, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    userTypes {
      ...UserType
    }
  }
}
    ${UserTypeFragmentDoc}`;

export function useUserTypesByKeywordQuery(options: Omit<Urql.UseQueryArgs<UserTypesByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<UserTypesByKeywordQuery, UserTypesByKeywordQueryVariables>({ query: UserTypesByKeywordDocument, ...options });
};
export const UsersDocument = gql`
    query Users($filter: UsersFilterInput!, $pagination: PaginatedInput!) {
  users(filter: $filter, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useUsersQuery(options: Omit<Urql.UseQueryArgs<UsersQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersQuery, UsersQueryVariables>({ query: UsersDocument, ...options });
};
export const UsersByDepartmentDocument = gql`
    query UsersByDepartment($departmentId: String!, $pagination: PaginatedInput!) {
  usersByDepartment(departmentId: $departmentId, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useUsersByDepartmentQuery(options: Omit<Urql.UseQueryArgs<UsersByDepartmentQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersByDepartmentQuery, UsersByDepartmentQueryVariables>({ query: UsersByDepartmentDocument, ...options });
};
export const UsersByKeywordDocument = gql`
    query UsersByKeyword($keyword: String!, $typeId: String, $roleType: UserRoleTypes, $status: UserStatus, $since: DateTime, $until: DateTime, $pagination: PaginatedInput!) {
  usersByKeyword(
    keyword: $keyword
    typeId: $typeId
    roleType: $roleType
    status: $status
    since: $since
    until: $until
    pagination: $pagination
  ) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useUsersByKeywordQuery(options: Omit<Urql.UseQueryArgs<UsersByKeywordQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersByKeywordQuery, UsersByKeywordQueryVariables>({ query: UsersByKeywordDocument, ...options });
};
export const UsersByTypeDocument = gql`
    query UsersByType($typeId: String!, $pagination: PaginatedInput!) {
  usersByType(typeId: $typeId, pagination: $pagination) {
    hasPrevPage
    hasNextPage
    currentPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

export function useUsersByTypeQuery(options: Omit<Urql.UseQueryArgs<UsersByTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersByTypeQuery, UsersByTypeQueryVariables>({ query: UsersByTypeDocument, ...options });
};
export const EnrolledTagByReaderIdDocument = gql`
    subscription enrolledTagByReaderId($readerId: String!) {
  enrolledTagByReaderId(readerId: $readerId) {
    ...EnrolledTag
  }
}
    ${EnrolledTagFragmentDoc}`;

export function useEnrolledTagByReaderIdSubscription<TData = EnrolledTagByReaderIdSubscription>(options: Omit<Urql.UseSubscriptionArgs<EnrolledTagByReaderIdSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<EnrolledTagByReaderIdSubscription, TData>) {
  return Urql.useSubscription<EnrolledTagByReaderIdSubscription, TData, EnrolledTagByReaderIdSubscriptionVariables>({ query: EnrolledTagByReaderIdDocument, ...options }, handler);
};
export const ReaderUpdateDocument = gql`
    subscription ReaderUpdate($readerId: String!) {
  readerUpdate(readerId: $readerId) {
    ...Reader
  }
}
    ${ReaderFragmentDoc}`;

export function useReaderUpdateSubscription<TData = ReaderUpdateSubscription>(options: Omit<Urql.UseSubscriptionArgs<ReaderUpdateSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<ReaderUpdateSubscription, TData>) {
  return Urql.useSubscription<ReaderUpdateSubscription, TData, ReaderUpdateSubscriptionVariables>({ query: ReaderUpdateDocument, ...options }, handler);
};
export const ReportUpdateDocument = gql`
    subscription ReportUpdate($reportId: String!) {
  reportUpdate(reportId: $reportId) {
    ...Report
  }
}
    ${ReportFragmentDoc}`;

export function useReportUpdateSubscription<TData = ReportUpdateSubscription>(options: Omit<Urql.UseSubscriptionArgs<ReportUpdateSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<ReportUpdateSubscription, TData>) {
  return Urql.useSubscription<ReportUpdateSubscription, TData, ReportUpdateSubscriptionVariables>({ query: ReportUpdateDocument, ...options }, handler);
};